import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { GUIDE_TOPICS } from './guide-content';

// Shown once, the first time a new portal account signs in — a super-admin
// grants access on the admin dashboard's Portal Access page, and the person
// who receives the invite has otherwise never seen this product before.
// "Once" is tracked in localStorage per uid (see ShellComponent) rather than
// on the account itself: it's a courtesy nudge, not a security or business
// fact, so nothing server-side needs to know it happened.
@Component({
  selector: 'portal-welcome-dialog',
  templateUrl: './welcome-dialog.component.html',
  styleUrls: ['./welcome-dialog.component.css']
})
export class WelcomeDialogComponent {

  topics = GUIDE_TOPICS;

  constructor(
    public ref: MatDialogRef<WelcomeDialogComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  get firstName(): string {
    return ((this.data && this.data.name) || '').split(' ')[0];
  }

  openHelp() {
    this.ref.close();
    this.router.navigate(['/help']);
  }
}
